// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.waitlist.RentalManagerUserPropertyWaitlistV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { UserPropertyWaitlistDisableV2RequestDto, UserPropertyWaitlistEnableV2RequestDto } from '../..';

export const RentalManagerUserPropertyWaitlistV2WebApiHandler_disable_Path =
  '/api/web/v2/users/properties/waitlist/disable';

/**
 * Disable waitlist feature for a property
 */
export const RentalManagerUserPropertyWaitlistV2WebApiHandler_disable = (
  postData: UserPropertyWaitlistDisableV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyWaitlistDisableV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyWaitlistV2WebApiHandler_disable_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyWaitlistV2WebApiHandler_enable_Path =
  '/api/web/v2/users/properties/waitlist/enable';

/**
 * Enable waitlist feature for a property
 */
export const RentalManagerUserPropertyWaitlistV2WebApiHandler_enable = (
  postData: UserPropertyWaitlistEnableV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyWaitlistEnableV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyWaitlistV2WebApiHandler_enable_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
